import clsx from "clsx";
import styles from "./Hero.module.less";

export const HeroImageWrapper = ({ className, children }) => {
  return <div className={clsx(styles.HeroImageWrapper, className)}>{children}</div>;
};
